import { render } from "./Section6.vue?vue&type=template&id=bf1f4f28"
import script from "./Section6.vue?vue&type=script&lang=js"
export * from "./Section6.vue?vue&type=script&lang=js"

import "./Section6.vue?vue&type=style&index=0&id=bf1f4f28&lang=css"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__